import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  approval: string;
  admin: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ApprovalLabel',
  props: {
    approval: {},
    admin: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([
      'approval-label',
      _ctx.admin == null
        ? 'approval-label-unconfirmed'
        : _ctx.approval === '0'
        ? 'approval-label-unapproval'
        : 'approval-label-approval',
    ])
  }, _toDisplayString(_ctx.admin === null ? '未承認' : _ctx.approval === '0' ? '未承認' : '承認済'), 3))
}
}

})